import { alpha, styled } from '@mui/material/styles';
import { OutlinedInput } from '@mui/material';

export const StyledSearch = styled(OutlinedInput)(({ theme }) => ({
    // "transition": theme.transitions.create(['box-shadow', 'width'], {
    //     easing: theme.transitions.easing.easeInOut,
    //     duration: theme.transitions.duration.shorter
    // }),
    // '&.Mui-focused': {
    //     boxShadow: theme.customShadows.z8
    // },
    '& fieldset': {
        borderWidth: `1px !important`,
        borderColor: `${alpha(theme.palette.grey[500], 0.32)} !important`
    }
}));